import sc from 'styled-components';

export const TooltipWrapper = sc.span`
    display: inline-block;
`;

export const TooltipBubble = sc.div<{$placement: string}>`
    position: fixed;
    min-width: 200px;
    max-width: 800px;
    width: auto;
    background: #fff;
    color: #222;
    padding: 12px 16px;
    border-radius: 8px;
    box-shadow: 0px 8px 32px rgba(38, 38, 74, 0.3), 0px 2px 8px rgba(0,0,0,0.12);
    box-sizing: border-box;
    font-size: 14px;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.2s;
    overflow-wrap: break-word;
    word-break: break-word;
    &.visible {
        opacity: 1;
        pointer-events: auto;
    }
`;